// src/redux/actions/cityActions.js
import {
    FETCH_GETORGDCOMP_REQUEST,
    FETCH_GETORGDCOMP_SUCCESS,
    FETCH_GETORGDCOMP_FAILURE,
    SET_SELECTED_GETORGDCOMP,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchOrgRegdCompData = (searchTerm = '') => async (dispatch) => {
    dispatch({ type: FETCH_GETORGDCOMP_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetAllOrgsDDL?Search=${searchTerm}&Type=Company`);
      console.log("getallorgsregdComp :", response);
      let getRegdCompList = response.data.responseData.map((val) => {
        return {
          value: val.id,
          label: val.name,
          tagId: val.tagID
        }
      })
      dispatch({
        type: FETCH_GETORGDCOMP_SUCCESS,
        payload: getRegdCompList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GETORGDCOMP_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectRegdComp = (getallorgsId) => ({
    type: SET_SELECTED_GETORGDCOMP,
    payload: getallorgsId,
  });
  